import {Component} from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';

import {rem, standardFont} from '-/styles/utils';

const styles = {
    root: {
        ...standardFont(),
        fontWeight: 'bold'
    },
    control: {
        marginBottom: rem(17)
    },
    flow: {
        display: 'block',
        position: 'absolute',
        top: rem(-25),
        left: 0
    }
};

class Legend extends Component {
    render() {
        const {type = 'control', className = '', classes = {}, children} = this.props;
        const baseType = classes[type];
        const cls = classNames(classes.root, baseType, className);

        return <legend className={cls}>{children}</legend>
    }
}

export default injectSheet(styles)(Legend);
